import { HelmetDexteel } from "@dexteel/mesf-core";
import { TableBreakRules } from "./components/TableBreakRules";

export const BreakSchedulesPage = () => (
	<>
		<HelmetDexteel title="Break Schedules - Configurations" />
		<TableBreakRules />
	</>
);
